import {isEmpty} from "../../../../components/commonmethod/CommonMethod";

function ChildrenCountNameRenderer({data}){
    
    if(data){
        const length = data.length;
        const str = length < 1 ? "0건" : data.length+"건";
        return(
            str
        )
    }
}

function codeTypeNameRenderer({data}){
    
    if(data){
        const str = data === "code" ? "자산 그룹별" : "협력 업체별";
        return(
            str
        )
    }
}

function countNameRenderer({data}){
    const str = !isEmpty(data) ? `${data} 건` : "";
    return(
        str
    )
}

export {ChildrenCountNameRenderer, codeTypeNameRenderer, countNameRenderer}